import React, { useState, useEffect } from "react";
import { Search, Download, Calendar, Filter } from "lucide-react";

const PremiumFilterBar = ({
    searchInput,
    setSearchInput,
    selectedStatus,
    setSelectedStatus,
    onDateChange,
    onExport,
    title,
    extraElement
}) => {
    const [range, setRange] = useState("");
    const [customRange, setCustomRange] = useState({ start: "", end: "" });

    useEffect(() => {
        let start = "";
        let end = "";
        const today = new Date();

        if (range === "today") {
            start = today.toISOString().split("T")[0];
            end = today.toISOString().split("T")[0];
        } else if (range === "yesterday") {
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            start = yesterday.toISOString().split("T")[0];
            end = yesterday.toISOString().split("T")[0];
        } else if (range === "last7") {
            const last7 = new Date(today);
            last7.setDate(today.getDate() - 6);
            start = last7.toISOString().split("T")[0];
            end = today.toISOString().split("T")[0];
        } else if (range === "month") {
            const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
            start = firstDay.toISOString().split("T")[0];
            end = today.toISOString().split("T")[0];
        } else if (range === "custom") {
            start = customRange.start || "";
            end = customRange.end || "";
        }

        if (onDateChange) {
            onDateChange({ start, end });
        }
    }, [range, customRange]);

    const handleCustomChange = (type, value) => {
        setCustomRange((prev) => ({ ...prev, [type]: value }));
    };

    return (
        <div style={{ marginBottom: "24px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: "16px", flexWrap: "wrap", gap: "16px" }}>
                <h2 style={{ fontSize: "24px", fontWeight: "700", color: "var(--primary)", fontFamily: "Outfit", margin: 0 }}>
                    {title}
                </h2>
                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                    {extraElement && extraElement}
                    {onExport && (
                        <button onClick={onExport} className="export-btn">
                            <Download size={18} />
                            Export Excel
                        </button>
                    )}
                </div>
            </div>

            <div className="filter-bar">
                {/* Search */}
                <div style={{ flex: 1, minWidth: "200px" }}>
                    <div className="premium-input-group">
                        <Search size={18} color="var(--text-muted)" />
                        <input
                            type="text"
                            placeholder="Search records..."
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="premium-input"
                        />
                    </div>
                </div>

                {/* Filters Group */}
                <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", alignItems: "center" }}>
                    {/* Status Filter */}
                    {setSelectedStatus && (
                        <select
                            className="premium-select"
                            value={selectedStatus}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                        >
                            <option value="">Status: All</option>
                            <option value="Requested">Requested</option>
                            <option value="Pending">Pending</option>
                            <option value="In Progress">In Progress</option>
                            <option value="Resolved">Resolved</option>
                            <option value="Closed">Closed</option>
                        </select>
                    )}

                    {/* Date Interval Filter */}
                    <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
                        <select
                            className="premium-select"
                            value={range}
                            onChange={(e) => setRange(e.target.value)}
                        >
                            <option value="">Date: All Time</option>
                            <option value="today">Today</option>
                            <option value="yesterday">Yesterday</option>
                            <option value="last7">Last 7 Days</option>
                            <option value="month">This Month</option>
                            <option value="custom">Custom Range</option>
                        </select>

                        {range === "custom" && (
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <input
                                    type="date"
                                    value={customRange.start}
                                    onChange={(e) => handleCustomChange("start", e.target.value)}
                                    className="premium-select"
                                    style={{ padding: "8px" }}
                                />
                                <span style={{ color: "var(--text-muted)", fontSize: "14px" }}>to</span>
                                <input
                                    type="date"
                                    value={customRange.end}
                                    onChange={(e) => handleCustomChange("end", e.target.value)}
                                    className="premium-select"
                                    style={{ padding: "8px" }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PremiumFilterBar;
